import React from 'react';
import {
  FormControl,
  FormLabel,
  TextField,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { FONT_FAMILIES } from '../constants/selectConstants';

export const LabelSettings = ({ 
  labelText, labelFontSize, fontFamily, labelBold, 
  labelItalic, showSemicolon, setProp 
}) => (
  <Accordion>
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Typography variant="subtitle2">Label Configuration</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <FormControl fullWidth margin="normal">
        <FormLabel>Label Text</FormLabel>
        <TextField
          value={labelText || ''}
          onChange={(e) => setProp(props => props.labelText = e.target.value)}
          size="small"
          placeholder="Enter label text"
        />
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Label Font Size</FormLabel>
        <TextField
          value={labelFontSize || 14}
          onChange={(e) => setProp(props => props.labelFontSize = parseInt(e.target.value) || 14)}
          size="small"
          type="number"
          inputProps={{ min: 8, max: 72 }}
        />
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Font Family</FormLabel>
        <Select
          value={fontFamily || 'inherit'}
          onChange={(e) => setProp(props => props.fontFamily = e.target.value)}
          size="small"
        >
          {FONT_FAMILIES.map(font => (
            <MenuItem key={font.value} value={font.value}>{font.label}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControlLabel
        control={
          <Checkbox
            checked={labelBold}
            onChange={(e) => setProp(props => props.labelBold = e.target.checked)}
          />
        }
        label="Bold label"
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={labelItalic}
            onChange={(e) => setProp(props => props.labelItalic = e.target.checked)}
          />
        }
        label="Italic label"
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={showSemicolon}
            onChange={(e) => setProp(props => props.showSemicolon = e.target.checked)}
          />
        }
        label="Show semicolon after label"
      />
    </AccordionDetails>
  </Accordion>
);